var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSheildTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91699 8.01536L6.74199 9.84036L10.7503 5.83203",
    stroke: "#178477",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 15.4317L7.41667 15.9067L6.58333 15.4317C4.80909 14.4074 3.33587 12.9338 2.31186 11.1594C1.28786 9.38494 0.749175 7.37212 0.750001 5.32339C0.750301 5.03112 0.827453 4.74407 0.973719 4.49103C1.11998 4.23799 1.33022 4.02786 1.58333 3.88173L6.65 0.956726C6.88282 0.821327 7.14734 0.75 7.41667 0.75C7.68599 0.75 7.95052 0.821327 8.18333 0.956726L13.25 3.88173C13.5031 4.02786 13.7134 4.23799 13.8596 4.49103C14.0059 4.74407 14.083 5.03112 14.0833 5.32339C14.0842 7.37212 13.5455 9.38494 12.5215 11.1594C11.4975 12.9338 10.0242 14.4074 8.25 15.4317Z",
    stroke: "#178477",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheildTick);
export default __webpack_public_path__ + "static/media/sheild-tick.8e102c03b5a1bf949dddf78da2bc463e.svg";
export { ForwardRef as ReactComponent };